<template>
    <th :colspan="colspan" v-if="data">
        {{ name }}
        <a v-if="data.id" href="#" @click.prevent.stop="$emit('editBilling', data)">({{ data.name }})</a>
    </th>
</template>

<script>
export default {
    props: [
        'data',
        'name',
        'colspan'
    ],
    data() {
        return {}
    }
}
</script>

<style>
</style>
